import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Paper, Dialog, DialogActions, DialogContent, DialogTitle, Grid} from '@material-ui/core'
import {Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Container, Box, IconButton} from '@material-ui/core'
import {Button, FormControl, Checkbox, TextField, InputLabel, Select } from '@material-ui/core';
import {MoreVert} from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

class EditFieldEnumDialog_ extends React.Component{

    constructor(props){
        super(props)

        const {field} = this.props;
        console.log('field')
        console.log(field)

        this.state = {
            field: field ? field : {
                Name: '',
                Values: []
            },
            errors:{
                ID: false,
                Name: false
            },
            changed: false,
        }

        this.handleInput = this.handleInput.bind(this)
        //this.handleFieldInput = this.handleFieldInput.bind(this)
        //this.handleAllowInput = this.handleAllowInput.bind(this)
    }

    handleSave(){
        if(this.validate()){

            let field =  {...this.props.field, ...this.state.field}

            console.log('FIELD_ENUM_EDITOR_SAVE')
            console.log(field)

            this.props.onAction({
                type: 'FIELD_ENUM_EDITOR_SAVE', 
                field: field, 
                fieldIndex: this.props.fieldIndex
            })
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'FIELD_ENUM_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'FIELD_ENUM_EDITOR_CLOSE'})
        }
    }

    handleInput(event, index){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const field = {...this.state.field}
        const values = [...field.Values] 

        values[index] = val

        field.Values = values
        //, [event.target.name]: val}
        this.setState({field: field, ...changed})
    }

    validate(){
        const {t} = this.props

        let errors = this.state.errors;
        let error = false

        /*
        if(!this.state.template.Name){
            errors.Name = t('NameIsEmpty')
            error = true
        }else{
            errors.Name = false
        }
        */

        this.setState({errors: errors})

        return !error;
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuItemClick(action, index){
        switch(action){
            case 'FIELD_ENUM_EDITOR_ITEM_DELETE':{

                let field = {...this.state.field}

                const values = [...field.Values]

                values.splice(index, 1)

                field.Values = values

                this.setState({
                    changed: true,
                    field: field, 
                    menuAnchor: null
                })
                break
            }
        }
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    handleMenuAddItemClick(event){
        let field = {...this.state.field}
        field.Values.push('')
        this.setState({field: field})
    }   

    handleMenuAddItemClose(event){
        this.setState({menuAddAnchor: null});
        event.stopPropagation();
    }

    render(){
        const {t} = this.props

        console.log('render EditFieldEnumDialog '+this.props.action)
        console.log('this.state.field');
        console.log(this.state.field);

        const title = this.props.action==='add'?t('NewEnum'):t('EditEnum')

        const margin = {margin:'16px 0 8px 0'}
        
        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:400}}>

            <Box textAlign="center">
                <TextField name="Name"  margin="normal" 
                    disabled={true}
                    style={{width: '100%'}}
                    label={this.state.errors.Name?this.state.errors.Name:t('FieldName')}
                    autoComplete="new-password"
                    error={this.state.errors.Name!==false}
                    value={this.state.field.Name}
                    onChange={this.handleInput}
                />
            </Box>


            
            <Box textAlign="center" style={{...margin, width: '100%'}}>
       
                <Paper style={{maxHeight: 250, overflow: 'auto'}}>
                <Table size="small">

                    <TableHead>
                        <TableRow>
                            <TableCell style={styles.head}>{t('Value')}</TableCell>
                            <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="more" component="span"
                                        style={styles.addIcon}
                                        onClick={(event)=>{this.handleMenuAddItemClick(event)}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.field.Values.map((value, index)=>{
                            return (
                                <TableRow key={index} >
                                    <TableCell>
                                        <TextField name="Name"  margin="normal"
                                            hiddenLabel
                                            style={{width: '100%'}}
                                            label={this.state.errors.Name?this.state.errors.Name:''}
                                            autoComplete="new-password"
                                            error={false}
                                            value={value}
                                            onChange={(event)=>this.handleInput(event, index)}
                                        />
                                    </TableCell>
                                    <TableCell style={{width:40}}>
                                        <IconButton size="small" color="inherit" aria-label="add" component="span"
                                            onClick={event=>this.handleMenuClick(event, index)}>
                                            <MoreVert />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                    </TableBody>

                    <Menu anchorEl={this.state.menuAnchor} keepMounted
                        open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                        <MenuItem onClick={()=>{this.handleMenuItemClick('FIELD_ENUM_EDITOR_ITEM_DELETE', this.state.menuItemID)}}>
                            <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                            <ListItemText primary={t('DeleteFieldItem')} />
                        </MenuItem>
                    </Menu>

                </Table>
                </Paper>

            </Box>  

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditFieldEnumDialog = withTranslation()(EditFieldEnumDialog_);